import { UIHeading5 } from '@cian/ui-kit/typography';

import { PhoneButton } from 'shared/components/common/PhoneButton';
import type { IPhone } from 'shared/types/phone';

import style from './style.css';

export interface IOfferContactsProps {
  /** Имя официального представителя — только на его вкладке; на вкладке агентов заголовка нет */
  name: string | null;
  phones: IPhone[];
}

/** Контакты в превью (`ObjectPhoneShow` монолита): кнопка заменяется номерами */
export const OfferContacts = ({ name, phones }: IOfferContactsProps) => (
  <div className={style['container']} data-name="OfferContacts">
    {name && <UIHeading5 as="h4">{name}</UIHeading5>}
    <PhoneButton phones={phones} />
  </div>
);
